const isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    iOS: function () {
        const ua = navigator.userAgent;
        return (
            /iPhone|iPad|iPod/i.test(ua) ||
            (/Macintosh/i.test(ua) && ('ontouchend' in document || navigator.maxTouchPoints > 1))
        ) && !window.MSStream;
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

const getScript = (url, callback) => new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = url
    script.async = true

    script.onerror = reject

    script.onload = script.onreadystatechange = function () {
        const loadState = this.readyState

        if (loadState && loadState !== 'loaded' && loadState !== 'complete') return

        script.onload = script.onreadystatechange = null

        if (typeof callback === 'function') {
            callback();
        }

        resolve()
    }

    document.head.appendChild(script)
})

const setHeightHeaderPictureMain = () => {
    const pictureOnMainPage = document.querySelector('.page--main .main-picture__picture');

    if (!pictureOnMainPage) return;

    const pictureOnMainText = document.querySelector('.page--main .main-picture__content').offsetHeight + 200;

    if (pictureOnMainPage.offsetHeight < pictureOnMainText) {
        pictureOnMainPage.style.height = pictureOnMainText + "px"
    }

    if (window.screen.width > 1325) {
        pictureOnMainPage.style.height = 'inherit';
    }
}

// if (document.querySelector('html').classList.contains('ios')) {
//     document.addEventListener('readystatechange', () => {
//         if (document.readyState === 'complete') {
//             setHeightHeaderPictureMain();
//             window.addEventListener("resize", setHeightHeaderPictureMain);
//         }
//     });
// } else {
//     document.addEventListener('DOMContentLoaded', () => {
//         setHeightHeaderPictureMain();
//         window.addEventListener("resize", setHeightHeaderPictureMain);
//     });
// }

export {isMobile, getScript, setHeightHeaderPictureMain};